import React from "react";
import { Link } from "react-router-dom";

export default function Button({
  href,
  children,
  external = false,
  internal = false,
}) {
  const content = (
    <>
      <span
        className="global-btn-bracket-l"
        style={{
          fontSize: "32px",
          fontWeight: "300",
          lineHeight: "1",
          position: "relative",
          top: "-1px",
        }}
      >
        [
      </span>
      <span
        className="global-btn-text-wrapper"
        style={{
          display: "inline-block",
          overflow: "hidden",
          padding: "0 8px",
          whiteSpace: "nowrap",
        }}
      >
        <span
          className="global-btn-text"
          style={{
            fontSize: "17px",
            fontWeight: "700",
            textTransform: "uppercase",
            letterSpacing: "3px",
            display: "inline-block",
          }}
        >
          {children}
        </span>
      </span>
      <span
        className="global-btn-bracket-r"
        style={{
          fontSize: "32px",
          fontWeight: "300",
          position: "relative",
          top: "-1px",
          lineHeight: "1",
        }}
      >
        ]
      </span>
    </>
  );

  const baseStyle = {
    fontFamily: "Inter, sans-serif",
    textDecoration: "none",
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    padding: "18px",
  };

  // Internal React Router Link
  if (internal) {
    return (
      <Link to={href} className="global-btn-link" style={baseStyle}>
        {content}
      </Link>
    );
  }

  // External Link
  return (
    <a
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      className="global-btn-link"
      style={baseStyle}
    >
      {content}
    </a>
  );
}
